import React, { useContext, useCallback } from 'react';
import { Box, InputLabel } from '@material-ui/core';
import { ColorPicker } from 'material-ui-color';

import { ConfigContext } from '../config';

export const ColorField = ({ id, label, ...props }) => {
  const { useConfig, setConfig } = useContext(ConfigContext);
  const value = useConfig(id);

  const handleChange = useCallback(
    ({ hex }) => {
      setConfig(id, `#${hex}`);
    },
    [setConfig, id],
  );

  return (
    <Box mt={1}>
      <InputLabel shrink id={`${id}-label`} margin="dense">
        {label}
      </InputLabel>
      <ColorPicker value={value} onChange={handleChange} disableAlpha />
    </Box>
  );
};

export default ColorField;
